// A backend ViesCheckStatus enum tükre (számként érkezik)
export enum ViesCheckStatus {
    Valid = 0,
    Invalid = 1,
    ServiceUnavailable = 2,
    Error = 3,
}

export default interface ViesCheckResult {
    status: ViesCheckStatus;
    countryCode: string;
    vatNumber: string;
    name: string;
    address: string;
    requestDate: string | null;
    requestIdentifier: string;
    message: string;
}
